import script from "./AlertInputSharp.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlertInputSharp.vue?vue&type=script&setup=true&lang=ts"

import "./AlertInputSharp.vue?vue&type=style&index=0&id=45158dd4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45158dd4"]])

export default __exports__